import RecordBase           from './Base';
import { useTranslation }   from 'react-i18next';
import { URL }              from '~/config/uri';

export default class TourImageRecord extends RecordBase {
    static defaultAttributes = {
        name:              '',
        sorter:            null,
        lang:              'pt-BR',
        is_active:         true,
        archive_id:        null,
        image:             null,
        image_base64:      null,
      };

  static _attributeNames = null;
  static get attributeNames(){
    const { t } = useTranslation();
    if(!this._attributeNames){
      this._attributeNames = {
        id:                t('tourImage.attributes.id'),
        name:              t('tourImage.attributes.name'),
        sorter:            t('tourImage.attributes.sorter'),
        archive_id:        t('tourImage.attributes.image_id'),
        image:             t('tourImage.attributes.image'),
        lang:              t('tourImage.attributes.lang'),
        is_active:         t('tourImage.attributes.is_active'),
        deleted_at:        t('tourImage.attributes.deleted_at'),
        updated_at:        t('tourImage.attributes.updated_at'),
        image_base64:      t('tourImage.attributes.image_base64'),
      };
    }

    return this._attributeNames;
  }

  getImageUrl(){
    return `${URL}${this.get('image').file_path}`;
  }

  toParams(attrs={}){
    const {
      name,
      sorter,
      lang,
      is_active,
      archive_id
    } = this.toObject();

    return {
      data:{
        attributes:{
          name,
          sorter,
          lang,
          is_active,
          archive_id,
          ...attrs,
        }
      }
    };
  }

}
